//Fire
import "../row1.css"
function Row(props) {
  return (
    <div className="row1-container">
      <div className="row1">
      <img src="https://about.att.com/ecms/dam/snr/2021/September2021/StoryLevelBanner/09142021_Apple_STORY_LEVEL_BANNER_1600x483.jpg"/>
      </div>

      <div className="row1" id="row1-2">
      <img src="https://www.ixbt.com/img/n1/news/2020/6/4/BRAVIA_PS5Banner_B-1300x333_large.png" />
      </div>
    </div>
    
  )
}

export default Row;
